/**
 * All known adunits
 *
 * Format: {platform}-{page}-{type}-{extraPlace}-{size}
 *
 * E.g. d-dp-d-si-300x250
 * d: desktop
 * dp: devpage
 * d: display
 * si: sidebar
 * 300x250: size
 *
 * dyn in the id will allow multiple registrations
 */ export const ADUNIT_MAP = {
    DesktopDevPageDisplaySide300x250: 'd-dp-d-si-300x250',
    DesktopDevPageSideVideoSide: 'd-dp-v-si',
    DesktopDevPageDisplayStage728x90: 'd-dp-d-st-728x90',
    DesktopComments728x90: 'd-dp-d-cmt-728x90',
    DesktopProfileBottomDisplay728x90: 'd-up-d-bot-728x90',
    DesktopProfileTopDisplay728x90: 'd-up-d-top-728x90',
    DesktopProfileVideo: 'd-up-v',
    DesktopAdhesion: 'd-anchor',
    MobileAdhesion: 'm-anchor',
    MobileDevPageVideoStage: 'm-dp-v-st',
    MobileDevPageDisplaySide300x250: 'm-dp-d-si-300x250',
    MobileGridDisplayDynamic300x250: 'm-up-d-grd-dyn-300x250'
};
export const ADUNIT_IDS = Object.values(ADUNIT_MAP);
export var AdProviders;
(function(AdProviders) {
    AdProviders["Nitro"] = 'nitro';
    AdProviders["Gak"] = 'da';
})(AdProviders || (AdProviders = {}));
export const ADUNIT_PROVIDER_SAFETY_KEY = {
    [AdProviders.Nitro]: 'contentRating',
    [AdProviders.Gak]: 'safety'
};
export function adunitMemo(last, next) {
    return last.safety === next.safety;
}
